module.exports = __webpack_public_path__ + "img/weather_R.5ba92e74.png";